import { AwsCredentials } from 'Data/s3'
import { useDataValue } from 'Simple/Data.js'
import View from './view.js'
import React, { useEffect } from 'react'

export default function Logic(props) {
  let isMediaMobile = useDataValue({
    context: 'media',
    path: 'mobile',
    viewPath: props.viewPath,
  })

  // zoom out the site in mobile devices to make it more usable
  useEffect(() => {
    if (isMediaMobile) {
      document.body.classList.add('mobile-scaled')
    } else {
      document.body.classList.remove('mobile-scaled')
    }

    return () => {
      document.body.classList.remove('mobile-scaled')
    }
  }, [isMediaMobile])

  return (
    <AwsCredentials viewPath={props.viewPath}>
      <View viewPath={props.viewPath} />
    </AwsCredentials>
  )
}
